__turbopack_context__.v({
  "active": "styles-module__ZRYoVq__active",
  "entitySelector": "styles-module__ZRYoVq__entitySelector",
  "entitySelectorInput": "styles-module__ZRYoVq__entitySelectorInput",
  "entitySelectorLabel": "styles-module__ZRYoVq__entitySelectorLabel",
  "entitySelectorText": "styles-module__ZRYoVq__entitySelectorText",
  "mobileEntity": "styles-module__ZRYoVq__mobileEntity",
  "selectMobile": "styles-module__ZRYoVq__selectMobile",
  "tabsButton": "styles-module__ZRYoVq__tabsButton",
  "tabsList": "styles-module__ZRYoVq__tabsList",
  "tabsMobile": "styles-module__ZRYoVq__tabsMobile",
  "tabsMobileActive": "styles-module__ZRYoVq__tabsMobileActive",
  "tabsMobileBtn": "styles-module__ZRYoVq__tabsMobileBtn",
  "tabsMobileInactive": "styles-module__ZRYoVq__tabsMobileInactive",
});
